/**
 * Ejecuta la división.
 * Devuelve el quotien
 *
 * @param {float} dividend:
 * @param {float} divisor:
 *
 * @return {float} el quotien
 */

import { isValidNumber } from '../number/isValidNumber';
import { getMultiplicator } from './getMultiplicator';

export function div(dividend, divisor) {
  if (!isValidNumber(dividend)) {
    throw new TypeError(`dividend is not a valid number: "${dividend}"`);
  }

  if (!isValidNumber(divisor) || !divisor) {
    throw new TypeError(`divisor is not a valid number: "${divisor}"`);
  }

  const multiplicator = getMultiplicator([dividend, divisor]);
  return (multiplicator * dividend) / (multiplicator * divisor);
}
